import React, { useEffect, useRef } from "react";
import styles from "../components/comp_css/chapter_58.module.css";
import { Link } from "@mui/material";
import { useRouter } from "next/router";
import Common_html from "./Common_html";
import BlockData from "../../../central-doctraine-json/chapter69.json";
import Head from "next/head";
export default function Chapter_69() {

  const router = useRouter()
  const location = useRouter();
  const { pathname } = location;

  // const corosalref = useRef()

  // useEffect(() => {
  //     if (corosalref.current) {
  //         corosalref.current.scrollIntoView({
  //             behavior: "smooth",
  //             block: "nearest",
  //             inline: "start"
  //         })
  //     }
  //     console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])
  return (
    <>
     
         <Head>
        <title>Central Doctrine | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Central Doctrine | School of Our Divine Infinite Being"
        ></meta>
        <meta
          property="og:title"
          content="Aleister Crowley: Occult Visionary and the Bridge to Modern Mysticism"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="og:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          property="og:description"
          content="Exploring Aleister Crowley’s legacy, from The Book of the Law to his later works, reveals a fusion of mystical insight, Eastern influences, and revelatory genius. Despite controversy, his teachings resonate with Neoplatonic thought, celebrating the divine within the material world and inspiring seekers toward unity, joy, and the deeper mysteries of spiritual reality."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=69"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta
          property="twitter:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/central_doctrinel_og_img.webp"
        ></meta>
        <meta
          property="twitter:image:alt"
          content="Illustration of a radiant, ethereal figure surrounded by a golden aura, symbolizing the Divine Infinite Being. The figure is positioned centrally, emanating light and energy, with abstract patterns representing spiritual interconnectedness and universal truth."
        ></meta>
        <meta
          name="twitter:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=69"
        ></meta>
        <meta
          name="twitter:title"
          content="Aleister Crowley: Occult Visionary and the Bridge to Modern Mysticism"
        ></meta>
        <meta
          name="twitter:description"
          content="From The Book of the Law to Magick Without Tears, Aleister Crowley’s work blends divine inspiration, ancient wisdom, and bold philosophy. His vision, aligned with Neoplatonism, affirms the sacredness of the material world and the unity of all existence—offering seekers profound pathways into the mysteries of reality and the art of spiritual transformation."
        ></meta>
        <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=69" />
      </Head>
       <Common_html BlockData={BlockData} />
    </>
  );
}
